const Loader = () => {
  return (
    <div className="Loader"><div></div><div></div><div></div><div></div></div>
  )
}

export default Loader